"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.escapeSelector = function (value) {
    // unicode of " formatted for css
    var quoteEscapeCss = '\\000022';
    // To support the case where the data-value fields has the char ",
    // we need to escape it using the Css repesentation of it.
    return value.replace(/"/g, quoteEscapeCss);
};
//# sourceMappingURL=util.js.map